import React from "react";
import { User, Settings, LogOut } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";

const Navbar = ({ role }) => {
  const navigate = useNavigate();

  const getBasePathForRole = () => {
    return role === "admin" ? "/admin" : "/project_associate";
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    navigate("/login");
  };

  // Get base path for current role
  const basePath = getBasePathForRole();

  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="Logo" />
      </div>
      <nav>
        <Link to={`${basePath}/dashboard`}>Dashboard</Link>
        <Link to={`${basePath}/create-project`}>Create Project</Link>
        <Link to={`${basePath}/manage-projects`}>Manage Projects</Link>
        {role === "admin" && (
          <Link to={`${basePath}/manage-users`}>Manage Users</Link>
        )}
      </nav>
      <div className="header-right">
        <div className="profile-wrapper">
          <div className="profile">
            <User />
          </div>
          <div className="dropdown-menu">
            <Link to={`${basePath}/profile`} className="dropdown-item">
              <Settings />
              Profile Settings
            </Link>
            <button className="dropdown-item logout" onClick={handleLogout}>
              <span className="item-icon">
                <LogOut />
              </span>
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;